module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-03.03969c35.png";